import React, {Component} from 'react';
import {
    View,
    StatusBar,
    Image,
    TextInput,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    FlatList, ActivityIndicator, ScrollView, StyleSheet,
    Text
} from "react-native"
import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import i18n from "../../../../I18n/i18n";
import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
import axios from "axios";
import HMSelectInput from "../../../../customviews/HMSelectInput";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMIcon from "../../../../customviews/HMIcon";

import HMAlert from "../../../../customviews/HMAlert";

import FloatingLabelInput from "../../../../customviews/input/floatLabelInput";
import {Tools} from "../../../../tools/Tools";
import Toast from "../../../../customviews/toast";
import HMFilesTest from "../../../../customviews/file/HMFilesTest";

let container = null;
export default class AddTaskOperationSatiaScreen extends Component {
    constructor(props) {
        super(props);
        container = this;


        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        this.state = {
            visibleModal: false,
            once: true,
            listImage: [],
            TypeDocumentsList: [],
            ListRoll: [
                {
                    id: 1, value: 'نماینده', label: 'نماینده فروش دفتر اراک',
                }, {
                    id: 2, value: 'مودم huawi 55', label: 'نماینده فروش دفتر ساوه',
                },
            ],
            ListTypeTask: [
                {
                    id: 1, value: 'نماینده', label: 'عمومی',
                }, {
                    id: 2, value: 'مودم huawi 55', label: 'شارژ پنل',
                },
            ],
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            listName: [],
        }

        this.props.callserviceActionRefresh();

    }

    componentDidMount() {


        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                )


            })
    }

    componentWillMount() {
        this.getData()
    }

    componentWillReceiveProps(props) {
        if (this.state.OneDo && props.results) {
            this.setState({
                OneDo: false,
                listImage: props.results,
            })
        }
    }


    getData() {
        this.setState({
                OneDo: true,
                typeRequest: "get",

            },
            () => {
                let paramss = {
                    "lang": i18n.locale,
                    "token": store.getState().reducerSplashSatiaScreen.token,

                    //"token_fb": this.props.DataSplashScreen.token_fb,

                };
                this.props.callService(
                    typeExport._baseUrlSatia + "operator_tk/CategoryTask",
                    //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
                    //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
                    paramss,
                    typeExport.TypeGetAddTaskOperationSatiaScreen,
                    "POST",
                    this.props.token
                );
            }
        )

    }

    checkInput() {
        let {title, SelectRollValue, SelectTypePriorityValue, SelectTypeTaskValue, description} = this.state;
        title = title && title.length > 0 ? title.trim() : title;
        if (Tools.CheckValue(title, true) && title.length >= 3) {
            if (SelectRollValue) {
                if (SelectTypePriorityValue) {
                    if (SelectTypeTaskValue) {

                        description = description && description.length > 0 ? description.trim() : description;
                        if (Tools.CheckValue(description, true) && description.length >= 3) {
                            this.setData();
                        }
                        else {
                            this.showToast("توضیحات را  صحیح وارد نمایید و باید بیشتر از سه حروف باشد", 'custom_error');

                        }

                    }
                    else {
                        this.showToast("نوع وظیفه را انتخاب نمایید", 'custom_error');
                    }
                }
                else {
                    this.showToast("الویت را انتخاب نمایید", 'custom_error');
                }
            }
            else {
                this.showToast("ارجاع به را انتخاب نمایید", 'custom_error');
            }

        }
        else {
            this.showToast("عنوان را  صحیح وارد نمایید و باید بیشتر از سه حروف باشد", 'custom_error');

        }

    }

    showToast(text, type) {
        Toast.show({
            // type: 'success | error | info',
            type: "custom_error",
            //  position: 'top | bottom',
            position: 'top',
            text1: i18n.t('constant.message'),
            text2: text,
            visibilityTime: 4000,
            autoHide: true,
            style: {backgroundColor: "#0f0f0f"},
            //  topOffset: 30,
            // bottomOffset: 40,
            onShow: () => {
            },
            onHide: () => {
            }
        })
    }

    setData() {
        let {title, description, phone, SelectTypePriorityValue, workNumber, SelectTypeTaskValue, listName, SelectRollValue} = this.state;
        this.setState({
                OneDo: true,
                typeRequest: "set",
            },
            () => {
                let paramss = {
                    "lang": i18n.locale,

                    "adslTell": phone,
                    "categoryType": SelectTypeTaskValue,
                    "title": title,
                    "description": description,
                    "status": 0,
                    "ccTo": JSON.stringify(listName),
                    "workTime": workNumber,
                    "priority": SelectTypePriorityValue,
                    "referTo": SelectRollValue ? SelectRollValue : null,


                    "image": this.state.pathImage,
                    "video": this.state.pathVideo,
                    "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
                    "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
                    "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,

                    "arrImage": this.state.arrImage,
                    //"token_fb": this.props.DataSplashScreen.token_fb,

                };
                this.props.callService(
                    typeExport._baseUrlSatia + "operator_tk/createNewTask",
                    //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
                    //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
                    paramss,
                    typeExport.TypeSetAddTaskOperationSatiaScreen,
                    "POST",
                    this.props.token
                );
            }
        )

    }


    render() {
        let {item} = this.props.route && this.props.route.params ? this.props.route.params : this.props;
        let {viewportWidth} = this.state;
        let checkResponsive = viewportWidth > 600;
        let {allResult} = this.props;

        let listUser = allResult && allResult.listUser ? allResult.listUser : [];
        let categoryTask = allResult && allResult.categoryTask ? allResult.categoryTask : [];
        let categoryPriority = allResult && allResult.categoryPriority ? allResult.categoryPriority : [];
        return (
            <View style={{position: 'relative', flex: 1}}>
                {/*<HMImageBackground/>*/}
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.Extras ?
                                null
                                : <HMActionBarSatia
                                    props={this.props} statusBarTransparent
                                    text={(item.name ? item.name : (item.title ? item.title : ''))}

                                    //  text={i18n.t('constant.Information')}

                                    menu
                                    back
                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }
                        <View style={{flex: 1,}}>
                            <ScrollView style={{flex: 1}}>
                                <View style={{width: "100%"}}>

                                    <View style={{
                                        flexDirection: checkResponsive ? 'row' : "column",
                                        width: "98%",
                                        alignSelf: 'center'
                                    }}>

                                        <View style={{
                                            flex: checkResponsive ? .5 : 1,
                                            paddingHorizontal: moderateScale(1)
                                        }}>
                                            {/*     <HMTextInputEfects
                                        onRef={scroll => container["inputNationalCode"] = scroll}

                                        refName={"NationalCode"}

                                        type={"CostumeFumi"}
                                        value={this.state.NationalCode}

                                        label={i18n.t('constant.NationalCode')}
                                        onChangeText={text => this.setState({
                                            NationalCode: text
                                        })}
                                        iconClass={"FontAwesomeIcon"}
                                        iconName={'phone'}
                                        keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputJob")}
                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}

                                    />*/}
                                            <FloatingLabelInput
                                                label={"عنوان"}
                                                value={this.state.title}
                                                staticLabel
                                                hintTextColor={'#aaa'}
                                                styleRoot={{
                                                    marginVertical: moderateScale(8),
                                                    width: "100%",
                                                    alignSelf: 'center',
                                                }}
                                                //mask="99 (99) 99999-9999"
                                                hint="عنوان را وارد نمایید"
                                                containerStyles={{
                                                    borderWidth: moderateScale(2),
                                                    paddingHorizontal: moderateScale(10),
                                                    backgroundColor: '#fff',
                                                    borderColor: 'blue',
                                                    borderRadius: moderateScale(8),
                                                }}
                                                customLabelStyles={{
                                                    colorFocused: 'red',
                                                    fontSizeFocused: moderateScale(12),
                                                }}
                                                labelStyles={{
                                                    backgroundColor: '#fff',
                                                    paddingHorizontal: moderateScale(5),
                                                }}
                                                inputStyles={{
                                                    color: 'blue',
                                                    paddingHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(2),
                                                    height: moderateScale(48),
                                                    outlineColor: Colors.transparent
                                                }}
                                                onChangeText={text => this._setState({title: text})}

                                            />


                                        </View>
                                        <View
                                            style={{
                                                flex: checkResponsive ? .5 : 1,
                                                paddingHorizontal: moderateScale(1),
                                            }}>
                                            {/* <HMTextInputEfects
                                        onRef={scroll => container["inputJob"] = scroll}

                                        refName={"Job"}

                                        type={"CostumeFumi"}
                                        value={this.state.Job}

                                        label={i18n.t('constant.Job')}
                                        onChangeText={text => this.setState({
                                            Job: text
                                        })}
                                        iconClass={"FontAwesomeIcon"}
                                        iconName={'phone'}
                                        // keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputTypeInjury")}

                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}

                                    />*/}

                                            <FloatingLabelInput
                                                label={"شماره تلفن مشترک"}

                                                value={this.state.phone}
                                                staticLabel
                                                hintTextColor={'#aaa'}
                                                //mask="99 (99) 99999-9999"
                                                styleRoot={{
                                                    marginVertical: moderateScale(8),
                                                    width: "100%",
                                                    alignSelf: 'center',
                                                }}

                                                hint="مربوط به (شماره تلفن مشترک)"
                                                containerStyles={{
                                                    borderWidth: moderateScale(2),
                                                    paddingHorizontal: moderateScale(10),
                                                    backgroundColor: '#fff',
                                                    borderColor: 'blue',
                                                    borderRadius: moderateScale(8),

                                                }}
                                                customLabelStyles={{
                                                    colorFocused: 'red',
                                                    fontSizeFocused: moderateScale(12),
                                                }}
                                                labelStyles={{
                                                    backgroundColor: '#fff',
                                                    paddingHorizontal: moderateScale(5),
                                                }}
                                                inputStyles={{
                                                    color: 'blue',
                                                    paddingHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(2),
                                                    height: moderateScale(48),
                                                    outlineColor: Colors.transparent
                                                }}
                                                onChangeText={text => this._setState({phone: text})}


                                                // isPassword
                                                togglePassword={false}
                                            />
                                        </View>

                                    </View>
                                    <View style={{
                                        flexDirection: "row",
                                        width: "98%",
                                        alignSelf: 'center',
                                        marginVertical: moderateScale(6),
                                    }}>
                                        {/*    <HMTextView
                                            //type={"bold"}
                                            text={"ارجاع به : "}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                //   marginEnd: moderateScale(10),

                                            }}/>*/}
                                        <View style={{flex: 1}}>
                                            <HMSelectInput DropdownModal
                                                           title={"ارجاع به : "}

                                                           onValueChange={(value, itemSelctInput) => {

                                                               let idx = listUser.findIndex(obj => obj.value == value);
                                                               let res = null;
                                                               if (idx !== -1) {
                                                                   res = listUser[idx]
                                                               }

                                                               this.setState({
                                                                       SelectRollValue: value,
                                                                       Roll: {
                                                                           ...res,
                                                                           index: idx
                                                                       } ? res : {
                                                                           label: i18n.t('constant.SelectItem'),
                                                                           value: idx,
                                                                           index: idx
                                                                       }
                                                                   },
                                                                   () => {
                                                                   }
                                                               )
                                                           }}
                                                // error={this.state.errorSelectInput}
                                                //
                                                // //  requestServerRetry={container.getServerTypeDocuments}
                                                // requestServer={() => {
                                                // }}
                                                           value={this.state.SelectRollValue ? this.state.Roll.label : i18n.t('constant.SelectItem')}
                                                           index={this.state.Roll ? this.state.Roll.index : -1}
                                                           itemSelectInput={this.state.Roll}
                                                           options={allResult && allResult.listUser ? allResult.listUser : []}

                                                           styleRoot={{
                                                               width: '100%'
                                                           }}
                                            />
                                        </View>
                                    </View>

                                    {/*       <FloatingLabelInput
                                    label={"رونوشت به :"}
                                    value={this.state.replay}
                                    staticLabel
                                    hintTextColor={'#aaa'}
                                    styleRoot={{
                                        marginVertical: moderateScale(8),
                                        //width: "100%",
                                        alignSelf: 'center',
                                        width: "98%",
                                    }}
                                    //mask="99 (99) 99999-9999"
                                    hint="رونوشت را وارد نمایید"
                                    containerStyles={{
                                        borderWidth: moderateScale(2),
                                        paddingHorizontal: moderateScale(10),
                                        backgroundColor: '#fff',
                                        borderColor: 'blue',
                                        borderRadius: moderateScale(8),

                                    }}
                                    customLabelStyles={{
                                        colorFocused: 'red',
                                        fontSizeFocused: moderateScale(12),
                                    }}
                                    labelStyles={{
                                        backgroundColor: '#fff',
                                        paddingHorizontal: moderateScale(5),
                                    }}
                                    inputStyles={{
                                        color: 'blue',
                                        paddingHorizontal: moderateScale(2),
                                        marginVertical: moderateScale(2),
                                        height: moderateScale(48),
                                        outlineColor: Colors.transparent
                                    }}
                                    onChangeText={text => this._setState({replay: text})}

                                />*/}

                                    <View
                                        style={{
                                            flexDirection: "row",
                                            width: "98%",
                                            alignSelf: 'center',
                                            marginVertical: moderateScale(6),
                                        }}>

                                        {/*  <HMTextView
                                            //type={"bold"}
                                            text={"رونوشت به : " + `( ${(this.state.listName && this.state.listName.length ? this.state.listName.length : 0)} ) `}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                //   marginEnd: moderateScale(10),

                                            }}/>*/}
                                        <View style={{flex: 1}}>
                                            <HMSelectInput DropdownModal
                                                           title={"رونوشت به : " + `( ${(this.state.listName && this.state.listName.length ? this.state.listName.length : 0)} ) `}
                                                           onValueChange={(value, itemSelectInput) => {


                                                               let idx = listUser.findIndex(obj => obj.value == value);
                                                               let idxListName = this.state.listName.findIndex(obj => obj.value == value);
                                                               let res = null;
                                                               var array = this.state.listName;
                                                               if (idx !== -1 && idxListName === -1) {
                                                                   res = listUser[idx]
                                                                   array = [...this.state.listName]; // make a separate copy of the array
                                                                   array.push(res);
                                                               }


                                                               this.setState({
                                                                   listName: array,
                                                                   SelectCCTaskValue: value,
                                                                   CCTask: res ? {
                                                                       ...res,
                                                                       index: idx
                                                                   } : {
                                                                       label: i18n.t('constant.SelectItem'),
                                                                       value: idx,
                                                                       index: idx
                                                                   }
                                                               })
                                                           }}
                                                // error={this.state.errorSelectInput}
                                                //
                                                // //  requestServerRetry={container.getServerTypeDocuments}
                                                // requestServer={() => {
                                                // }}
                                                           value={this.state.SelectCCTaskValue ? this.state.CCTask.label : i18n.t('constant.SelectItem')}
                                                           index={this.state.CCTask ? this.state.CCTask.index : -1}
                                                           itemSelectInput={this.state.CCTask}
                                                           options={allResult && allResult.listUser ? allResult.listUser : []}

                                                           styleRoot={{
                                                               width: '100%'
                                                           }}
                                            />

                                        </View>

                                    </View>
                                    <View style={{marginHorizontal: moderateScale(8),}}>

                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: "row",
                                                flexWrap: 'wrap',
                                                flex: 1,

                                                flexGrow: 1,
                                                alignItems: 'center',
                                                //justifyContent: 'center',
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                //  backgroundColor: "#876a79",
                                            }}>
                                            {
                                                this.state.listName.map((item, index) => {
                                                    return <View
                                                        onPress={() => {

                                                        }
                                                        }
                                                        style={{
                                                            paddingHorizontal: moderateScale(3),
                                                            backgroundColor: Colors.colorSecondPrimary,
                                                            borderRadius: moderateScale(4),
                                                            marginHorizontal: moderateScale(2),
                                                            marginVertical: moderateScale(2),
                                                        }}
                                                    >
                                                        <View style={[{
                                                            //marginVertical: moderateScale(15),
                                                            height: moderateScale(30),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexDirection: 'row'
                                                        }]}>
                                                            {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                                            {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                                            <HMTextView text={item.label} type={"bold"}
                                                                        style={{
                                                                            color: Colors.blackLight,
                                                                            marginHorizontal: moderateScale(6),
                                                                            fontSize: moderateScale(11),
                                                                            textAlign: 'center'
                                                                        }}/>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    var array = [...this.state.listName]; // make a separate copy of the array

                                                                    if (this.state.SelectCCTaskValue === this.state.listName[index].value) {
                                                                        this.setState({
                                                                            SelectCCTaskValue: -1,
                                                                            CCTask: {
                                                                                label: i18n.t('constant.SelectItem'),
                                                                                value: -1,
                                                                                index: -1
                                                                            }
                                                                        })
                                                                    }
                                                                    array.splice(index, 1);
                                                                    this.setState({listName: array});


                                                                    /*    let arr= this.state.listName
                                                                        this.setState({
                                                                            listName: arr.splice(index, 1)
                                                                        })*/
                                                                }}
                                                                style={{alignSelf: 'center'}}>
                                                                <HMIcon name={"md-close"} style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: '#0f0f0f'
                                                                }}/>
                                                            </TouchableOpacity>


                                                        </View>
                                                        {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

                                                    </View>
                                                })
                                            }
                                        </View>

                                        {/*       <FlatList
                                                style={{height: moderateScale(30)}}
                                                // data={data.results.all_categories}
                                                data={this.state.listName}
                                                renderItem={({item, index}) =>

                                                    <View
                                                        onPress={() => {

                                                        }
                                                        }
                                                        style={{
                                                            paddingHorizontal: moderateScale(3),
                                                            backgroundColor: Colors.colorSecondPrimary,
                                                            borderRadius: moderateScale(4),
                                                            marginHorizontal: moderateScale(2)
                                                        }}
                                                    >
                                                        <View style={[{
                                                            //marginVertical: moderateScale(15),
                                                            height: moderateScale(30),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexDirection: 'row'
                                                        }]}>
                                                            <HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}
                                                            style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/>
                                                            <HMTextView text={item.label} type={"bold"}
                                                                        style={{
                                                                            color: Colors.blackLight,
                                                                            marginHorizontal: moderateScale(6),
                                                                            fontSize: moderateScale(11),
                                                                            textAlign: 'center'
                                                                        }}/>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    var array = [...this.state.listName]; // make a separate copy of the array

                                                                    array.splice(index, 1);
                                                                    this.setState({listName: array});
                                                                }}
                                                                style={{alignSelf: 'center'}}>
                                                                <HMIcon name={"md-close"} style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: '#0f0f0f'
                                                                }}/>
                                                            </TouchableOpacity>


                                                        </View>
                                                    </View>
                                                }
                                                horizontal={true}
                                                showsHorizontalScrollIndicator={false}
                                                keyExtractor={(item, index) => index.toString()}
                                                inverted={true}
                                            />*/}

                                    </View>


                                    <View style={{
                                        flexDirection: checkResponsive ? 'row' : "column",
                                        width: "98%",
                                        alignSelf: 'center'
                                    }}>

                                        <View style={{
                                            flex: checkResponsive ? .5 : 1,
                                            paddingHorizontal: moderateScale(1)
                                        }}>
                                            <FloatingLabelInput
                                                label={"تعداد روزکاری"}
                                                value={this.state.workNumber}
                                                staticLabel
                                                hintTextColor={'#aaa'}
                                                styleRoot={{
                                                    marginVertical: moderateScale(8),
                                                    width: "98%",
                                                    alignSelf: 'center',
                                                }}
                                                //mask="99 (99) 99999-9999"
                                                hint="پیش فرض ۲ روز کاری میباشد"
                                                containerStyles={{
                                                    borderWidth: moderateScale(2),
                                                    paddingHorizontal: moderateScale(10),
                                                    backgroundColor: '#fff',
                                                    borderColor: 'blue',
                                                    borderRadius: moderateScale(8),
                                                }}
                                                customLabelStyles={{
                                                    colorFocused: 'red',
                                                    fontSizeFocused: moderateScale(12),
                                                }}
                                                labelStyles={{
                                                    backgroundColor: '#fff',
                                                    paddingHorizontal: moderateScale(5),
                                                }}
                                                inputStyles={{
                                                    color: 'blue',
                                                    paddingHorizontal: moderateScale(2),
                                                    marginVertical: moderateScale(2),
                                                    height: moderateScale(48),
                                                    outlineColor: Colors.transparent
                                                }}
                                                onChangeText={text => this._setState({workNumber: text})}

                                            />

                                        </View>
                                        <View
                                            style={{
                                                flex: checkResponsive ? .5 : 1,
                                                paddingHorizontal: moderateScale(1),
                                                justifyContent: 'center'

                                            }}>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    width: "98%",
                                                    alignSelf: 'center',
                                                    marginVertical: moderateScale(6),
                                                }}>

                                                {/*    <HMTextView
                                                    //type={"bold"}
                                                    text={"الویت : "}
                                                    //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                    style={{
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),
                                                        //   marginEnd: moderateScale(10),

                                                    }}/>*/}
                                                <View style={{flex: 1}}>
                                                    <HMSelectInput DropdownModal
                                                                   title={"الویت : "}
                                                                   onValueChange={(value) => {


                                                                       let idx = categoryPriority.findIndex(obj => obj.value == value);
                                                                       let res = null;
                                                                       if (idx !== -1) {
                                                                           res = categoryPriority[idx]
                                                                       }


                                                                       this.setState({
                                                                           SelectTypePriorityValue: value,
                                                                           TypePriority: res ? {
                                                                               ...res,
                                                                               index: idx
                                                                           } : {
                                                                               label: i18n.t('constant.SelectItem'),
                                                                               value: idx,
                                                                               index: idx
                                                                           }
                                                                       })
                                                                   }}
                                                        // error={this.state.errorSelectInput}
                                                        //
                                                        // //  requestServerRetry={container.getServerTypeDocuments}
                                                        // requestServer={() => {
                                                        // }}
                                                                   value={this.state.SelectTypePriorityValue ? this.state.TypePriority.label : i18n.t('constant.SelectItem')}
                                                                   index={this.state.TypePriority ? this.state.TypePriority.index : -1}
                                                                   itemSelectInput={this.state.TypePriority}
                                                                   options={categoryPriority}

                                                                   styleRoot={{
                                                                       width: '100%'
                                                                   }}
                                                    />

                                                </View>

                                            </View>
                                        </View>

                                    </View>

                                    <View
                                        style={{
                                            flexDirection: "row",
                                            width: "98%",
                                            alignSelf: 'center',
                                            marginVertical: moderateScale(6),
                                        }}>

                                        {/*    <HMTextView
                                            //type={"bold"}
                                            text={"نوع وظیفه : "}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                //   marginEnd: moderateScale(10),

                                            }}/>*/}
                                        <View style={{flex: 1}}>
                                            <HMSelectInput DropdownModal
                                                           title={"نوع وظیفه : "}

                                                           onValueChange={(value) => {


                                                               let idx = categoryTask.findIndex(obj => obj.value == value);
                                                               let res = null;
                                                               if (idx !== -1) {
                                                                   res = categoryTask[idx]
                                                               }


                                                               this.setState({
                                                                   SelectTypeTaskValue: value,
                                                                   TypeTask: res ? {
                                                                       ...res,
                                                                       index: idx
                                                                   } : {
                                                                       label: i18n.t('constant.SelectItem'),
                                                                       value: idx,
                                                                       index: idx
                                                                   }
                                                               })
                                                           }}
                                                // error={this.state.errorSelectInput}
                                                //
                                                // //  requestServerRetry={container.getServerTypeDocuments}
                                                // requestServer={() => {
                                                // }}
                                                           value={this.state.SelectTypeTaskValue ? this.state.TypeTask.label : i18n.t('constant.SelectItem')}
                                                           index={this.state.TypeTask ? this.state.TypeTask.index : -1}
                                                           itemSelectInput={this.state.TypeTask}
                                                           options={allResult && allResult.categoryTask ? allResult.categoryTask : []}

                                                           styleRoot={{
                                                               width: '100%'
                                                           }}
                                            />

                                        </View>

                                    </View>
                                    <FloatingLabelInput
                                        label={"توضیحات"}
                                        value={this.state.description}
                                        staticLabel
                                        hintTextColor={'#aaa'}
                                        styleRoot={{
                                            marginVertical: moderateScale(8),
                                            width: "98%",
                                            alignSelf: 'center',
                                        }}
                                        //mask="99 (99) 99999-9999"
                                        hint="توضیحات را وارد نمایید"
                                        containerStyles={{
                                            borderWidth: moderateScale(2),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: '#fff',
                                            borderColor: 'blue',
                                            borderRadius: moderateScale(8),
                                        }}
                                        customLabelStyles={{
                                            colorFocused: 'red',
                                            fontSizeFocused: moderateScale(12),
                                        }}
                                        labelStyles={{
                                            backgroundColor: '#fff',
                                            paddingHorizontal: moderateScale(5),
                                        }}
                                        inputStyles={{
                                            color: 'blue',
                                            paddingHorizontal: moderateScale(2),
                                            marginVertical: moderateScale(12),
                                            height: moderateScale(80),
                                            outlineColor: Colors.transparent
                                        }}
                                        onChangeText={text => this._setState({description: text})}

                                        multiline={true}
                                    />

                                    {/*            <HMFiles stateParent={this.state} func={container._setDataFiles}
                                             _setStateData={container._setStateData}/>*/}

                                    <HMFilesTest
                                        stateParent={this.state}
                                        _setStateData={container._setStateData}
                                        // _setStateDataParent={container.props._setStateData}
                                        SizeBox={3}
                                        //styleRoot2={{flexDirection: 'row',}}
                                        //clearState={this.clearState}
                                        styleRoot2={{
                                            flexDirection: 'row',
                                            flexWrap: 'wrap',
                                            width: "100%",

                                            // flexGrow: 1,
                                            //  backgroundColor: "#ee04d0",
                                            alignItems: "flex-start"

                                        }}
                                    />
                                </View>
                            </ScrollView>
                            <TouchableOpacity
                                style={{
                                    backgroundColor: Colors.colorPrimary,
                                    //width: "93%",
                                    width: "93%",
                                    height: moderateScale(40),
                                    alignSelf: 'center',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginVertical: moderateScale(8),
                                    borderRadius: moderateScale(6)
                                    // borderRadius:moderateScale(2)
                                }}
                                onPress={() => this.checkInput()}
                            >
                                <View style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <HMTextView type={"bold"} text={"ثبت"} style={{
                                        color: "white",
                                        fontSize: moderateScale(15),
                                        //marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>
                            {
                                this.props.NoInternetDialog || this.props.NoInternetDialogSet ?
                                    <DialogConnectionCustomize
                                        // again
                                        onPress={() => {
                                            this.setState({
                                                    isLoadingUpload: false,
                                                    errorUpload: false,
                                                    visibleModal: '',
                                                },
                                                () => {
                                                    this.state.typeRequest === "set" ?
                                                        this.checkInput()
                                                        :
                                                        this.getData()
                                                }
                                            )
                                            // this.loadingButton.showLoading(false),
                                            //    this.props.callserviceActionRefresh()
                                        }}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading || this.props.isLoadingSet || this.state.isLoadingUpload ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }
                            {
                                // this.ModalSelectImage()
                            }
                        </View>


                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    _setDataFiles(name, data) {
        container.setState({[name]: data});
    }


    _setStateData(object) {
        container.setState(object);
    }

    getNameDocuments(typeDocuments) {
        //  let idx = this.props.TypeDocumentsList.findIndex(obj => obj.value == this.state.typeDocuments);
        let idx = this.props.TypeDocumentsList.findIndex(obj => obj.value == typeDocuments);
        if (idx !== -1) {
            let r = this.props.TypeDocumentsList[idx]
            return {label: r.label, value: r.value, index: idx}

        }
        else
            return {label: i18n.t('constant.SelectItem'), value: idx, index: idx}

    }

    /*    handleUpload(onComplete, onFail) {
            return event => {
                const file = event.target.files[0];
                if (!/^image\//.test(file.type)) {
                    const data = {cancelled: false, error: "Not an image."};
                    onFail(data);
                    return;
                }

                const reader = new FileReader();

                reader.onload = (event) => {


                    const image = new Image({
                        source: file, onLoad: (event, uriiii) => {
                            alert("jkdfh")
                            const {width, height} = event.target;
                            const uri = event.target.src;

                            const data = {cancelled: false, uri, width, height};
                            onComplete(data);
                        }
                    });

                    // const image = new Image();
                    image.src = event.target.result;

                    image._onLoad
                    /!*
                                    image._onLoad = (event,uriiii) => {
                                        alert("jkdfh")
                                        const { width, height } = event.target;
                                        const uri = event.target.src;

                                        const data = { cancelled: false, uri, width, height };
                                        onComplete(data);
                                    };*!/
                };

                reader.onerror = err => {
                    const data = {cancelled: false, error: err};
                    onFail(data);
                };

                reader.onabort = err => {
                    const data = {cancelled: false, error: err};
                    onFail(data);
                };

                reader.readAsDataURL(file);
            };
        }*/

    _handleImage = ({uri}) => {

        this.setState(() => ({uri}));
    };

    _handleFail = ({error}) => {
        console.log(error);
    };

    fileSelect = async event => {
        let image = await Tools.resizeFile(event.target.files[0]);


        this.uploadFile(image, true)
    }

    _setState(obj, func) {
        this.setState(obj, func ? func() : null);
    }

    /*    ModalSelectImage() {
            return (
                <HMModal
                    // style={{backgroundColor: Colors.transparent}}
                    // position={"center"}
                    // ref={"modal"}
                    // backdropPressToClose={true}
                    // coverScreen={true}
                    // swipeToClose={true}
                    // backButtonClose={true}
                    // isOpen={this.state.visibleModal}
                    // onClosed={() => this.setState({visibleModal: false})}

                    isVisible={this.state.visibleModal}
                    //visible={this.state.visibleModal}
                    backdropColor={Colors.gray}
                    backdropOpacity={0.8}
                    animationIn="zoomInDown"
                    animationOut="zoomOutUp"
                    animationInTiming={600}
                    animationOutTiming={600}
                    backdropTransitionInTiming={600}
                    backdropTransitionOutTiming={600}
                    //style={{height: '60%'}}
                    onBackdropPress={() => this.setState({visibleModal: false})}
                    onBackButtonPress={() => this.setState({visibleModal: false})}

                    animationType="slide"
                >


                    <View style={{width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}>

                        <View style={{
                            width: '94%',
                            //  justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: Colors.white,
                            marginHorizontal: moderateScale(10),
                            // alignSelf: 'center',

                            // height:typeExport._WIDTH/2.7
                        }}>
                            {
                                Platform.OS === "web" ?
                                    <View style={{width: '100%', padding: moderateScale(10)}}>
                                        {/!*       <input id="upload_img_btn" type="file" name="image" className="file-upload-native"
                                               accept="image/!*"
                                        />*!/}
                                        <HMTextView
                                            text={"فایل مورد نظر خود را انتخاب نمایید"}
                                            type={'bold'}
                                            styleRoot={{
                                                //alignSelf: 'center',
                                            }}
                                            style={{
                                                //   alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                // margin: moderateScale(6),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(13),
                                                marginBottom: moderateScale(10)
                                            }}/>
                                        <label
                                            onChange={this.fileSelect}

                                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                            style={{
                                                flex: 1,
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                            <input type="file" accept="image/!*"/>

                                        </label>
                                    </View>
                                    :
                                    <View style={{width: '100%'}}>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openCamera(typeExport.optional).then(image => {
                                                    this.uploadFile(image);
                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                margin: moderateScale(5),
                                                padding: moderateScale(8),
                                                borderRadius: moderateScale(4),

                                            }}>
                                            <HMTextView
                                                text={"گرفتن عکس"}
                                                type={'bold'}
                                                style={{
                                                    //   alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                        <TouchableOpacity
                                            onPress={() => {
                                                ImagePicker.openPicker({
                                                    width: 1000,
                                                    height: 1000,
                                                    crop: true,

                                                    //   cropping: true
                                                }).then(image => {
                                                    // this.state.listImage.push(image)
                                                    this.uploadFile(image);


                                                });
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#eee',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                borderRadius: moderateScale(4)
                                            }}>
                                            <HMTextView
                                                text={"انتخاب عکس از گالری"}
                                                type={'bold'}
                                                style={{
                                                    // alignSelf: 'center',
                                                    //  marginRight: moderateScale(6),
                                                    // margin: moderateScale(6),
                                                    textAlign: 'center',
                                                    color: Colors.colorDarkText,
                                                    fontSize: moderateScale(14),
                                                }}/>
                                        </TouchableOpacity>
                                    </View>
                            }


                        </View>


                    </View>
                </HMModal>
            );
        }*/

    uploadFile(image, web) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        // let DateTime = new Date().getTime()
        // let nameImage = DateTime + '.jpg';
        if (web) {
            formData.append('image0', image, image.name + ".JPG");
            /*   formData.append('image' + ii, {
                   uri: image,
                   name: image.name,
                   type: 'image/jpeg'
               });*/
        } else {
            let arr = []
            for (let i = 0; i < 1; i++) {
                let ii = i + 1;
                let DateTime = new Date().getTime()
                let nameImage = DateTime + "_" + ii + '.jpg';
                formData.append('image' + ii, {
                    uri: image.path,
                    name: nameImage,
                    type: 'image/jpeg'
                });

            }
        }

        //   if (image && image !== null) formData.append('image[]', arr);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/uploadFiles",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

            // onUploadProgress:progressEvent=>{
            // }
            // onUploadProgress: function (progressEvent) {
            // },
        })
        //   axios.post(typeExport._baseUrlSatia + "user/uploadFiles", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.status) {
                    this.setState({
                        //ShowImage:true
                        listImage: data.result,
                        //TypeDocumentsList:[],
                        isLoadingUpload: false,
                        errorUpload: !data.status,
                        visibleModal: '',
                        pathImage: image.path
                    })
                }
                else {
                    this.ShowError(image, response)
                }

            }).catch((e) => {
            this.ShowError(image)


            console.log('error', e)
        })
    }

    ShowError(image, response) {
        this.setState({
                //ShowImage:true
                // listImage:  data.status ? data.result : this.state.listImage,
                //TypeDocumentsList:[],
                isLoadingUpload: false,
                errorUpload: true,
                visibleModal: '',
                pathImage: image ? image.path : null
            },
            () => {
                HMAlert(
                    i18n.t('constant.message'),
                    response ? response.data.message : i18n.t('constant.retry'),
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
            })
    }

    removeFile(item) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            //pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('serial', item.item.Serial);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT
            }
        };

        // axios.post(typeExport._baseUrlSatia + "user/deleteFiles", formData, config)
        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/deleteFiles",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
            .then(async response => {
                let data = response.data;

                //  data.status ? this.state.listImage.push(image) : null;
                if (data.status) {
                    let r = "select" + item.index;
                    this.state.listImage.splice(item.index, 1)
                    this.setState({
                        pathImage: null,
                        [r]: -1,
                        isLoadingUpload: false,
                        errorUpload: false,
                        visibleModal: '',
                    })

                }
                else {
                    this.ShowError(null, response)

                }

            }).catch((e) => {
            this.ShowError(null)

            console.log('error', e)
        })
    }

    editFile(index, item, indexCategory, valueCategory) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            //pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('serial', item.Serial);
        formData.append('MadrakType', valueCategory);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT
            }
        };

        //   axios.post(typeExport._baseUrlSatia + "user/editFile", formData, config)
        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/editFile",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
            .then(async response => {
                let data = response.data;

                //  data.status ? this.state.listImage.push(image) : null;
                if (data.status) {
                    let r = this.state.listImage;

                    // let idx = r.findIndex(obj => obj.Serial === item.item.Serial);

                    let t = this.props.TypeDocumentsList[indexCategory]
                    if (index > -1) {
                        r[index].CategoryType = t
                    }
                    // let r = "select" + item.index;
                    // this.state.listImage.splice(item.index, 1)
                    this.setState({
                        pathImage: null,
                        listImage: r,
                        isLoadingUpload: false,
                        errorUpload: false,
                        visibleModal: '',
                    })
                }
                else {
                    this.ShowError(null, response)

                }

            }).catch((e) => {

            this.ShowError(null)

            console.log('error', e)
        })
    }

    selectImages() {
        this.setState({
            visibleModal: "selectImage"
        })
    }

}

